"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentRemove_1 = require("./ComponentRemove");
var ComponentRemoveStore = new ComponentRemove_1.ComponentRemove();
exports.ComponentRemoveStore = ComponentRemoveStore;
